import React from "react";
import TableHeader from "./TableHeader";
import Tbody from "./Tbody";

const Table = ({ columns, sortColumn, onSort, data }) => {
  return (
    <table className="table">
      <TableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} />
      <Tbody data={data} columns={columns} />
    </table>
  );
};

export default Table;
